import i18n from '@/plugins/i18n'
import Model from '@/shared/orm/Model'

export default class Category extends Model {
    resourceName() {
        return 'categories'
    }

    fields() {
        return [
            'name',
            'description',
            'percent',
            'discount_percentage',
            'badge_icon',
            'badge_color',
        ]
    }

    appends() {
        return ['reseller_type_ids']
    }

    get availableIcons() {
        return [
            'mdi-seal',
            'mdi-medal',
            'mdi-trophy-variant',
            'mdi-trophy-award',
            'mdi-bullseye-arrow',
        ]
    }

    get tableColumns() {
        return [
            {
                text: i18n.t('resources.category.attributes.name'),
                value: 'name',
                sortable: true,
            },
            {
                text: i18n.t('resources.category.attributes.percent'),
                value: 'percent',
                sortable: false,
                align: 'center',
            },
            {
                text: i18n.t(
                    'resources.category.attributes.discount_percentage',
                ),
                value: 'discount_percentage',
                sortable: false,
                align: 'center',
            },
            {
                text: i18n.t('resources.category.attributes.reseller_type_ids'),
                value: 'reseller_types',
                sortable: false,
                align: 'center',
            },
            {
                text: i18n.t('tables.actions'),
                value: 'action',
                sortable: false,
                align: 'end',
            },
        ]
    }
}
